export default {"src":"/_next/static/media/automated-and-manual-assessments.8621a2a8.svg","height":488,"width":548,"blurWidth":0,"blurHeight":0};